const details = {
    name: "لوازم ورزشی رکورد",
    enName: "shop",
    description: "لوازم ورزشی رکورد",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "طراحی سایت ورزشی",
        link: "https://barantm.com/landing/sports-website-design"
    }
}

export default details;
